export default __webpack_public_path__ + "static/media/loader.c1ebde41.gif";